import logo from 'assets/images/logo.png';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    return <img src={logo} alt="BrooklynDonuts" width="150" />;
};

export default Logo;
